import React, { useState } from 'react'
import { UserColumns, UserData } from './UserData';
import DataTableHeader from '../../../../../Common/DataTableHeader/DataTableHeader';
import DataTable from '../../../../../Common/DataTable/DataTable';
import DataTableFooter from '../../../../../Common/DataTableFooter/DataTableFooter';

const UserTable = () => {

    const [data, setData] = useState(UserData)
    const handleDelete = (id) => {
        setData(prevData => prevData.filter(item => item.id !== id));
    }
    const dataT = data.map((data) => {
        return {
            id: data.id,
            name: data.name,
            image: (
                <img className="rounded-xl h-10 w-10" src={data.image} alt='avatars' />
            ),
            status: data.status,
            action: (
                <>
                    <button type="button" className="text-red-700 hover:text-red-800 focus:outline-none rounded-md p-2 deleterow" onClick={() => handleDelete(data.id)}><i
                        className="bi bi-trash text-danger"></i></button>
                </>
            ),
        };
    });

    return (
        <div className='h-full px-4'>
            <DataTableHeader />
            <DataTable columns={UserColumns} data={dataT} />
            <DataTableFooter dataT={dataT} />
        </div>
    )
}

export default UserTable